import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { UploadFailureReason } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface PendingFailure {
  filename: string;
  extension: string;
  rejectedReason: UploadFailureReason.UnsupportedFileFormat;
}

interface SendPendingFailuresParams {
  caseId: string;
  uploadId: string;
  failures: PendingFailure[];
}

export const useSendPendingFailures = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(
    async ({ caseId, uploadId, failures }: SendPendingFailuresParams) => {
      if (failures.length === 0) {
        return;
      }

      for (const failure of failures) {
        const fetchConfig = getFetchConfig({
          method: FetchMethod.POST,
          data: {
            filename: failure.filename,
            extension: failure.extension,
            uploadId,
            caseId,
            rejectedReason: failure.rejectedReason,
          },
        });

        await fetch(`${APIBaseChronos}/api/case/${caseId}/upload-metadata/failure`, fetchConfig);
      }
    },
    {
      onError: (error) => {
        console.error('Failed to record upload failures:', error);
      },
    },
  );
};
